import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2dba90af = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3aa5a4ed = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _76ec7645 = () => interopDefault(import('../pages/bloger/index.vue' /* webpackChunkName: "pages/bloger/index" */))
const _23ea8700 = () => interopDefault(import('../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _0612d276 = () => interopDefault(import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _45161f92 = () => interopDefault(import('../pages/about/team.vue' /* webpackChunkName: "pages/about/team" */))
const _b289b784 = () => interopDefault(import('../pages/Policy/privacy.vue' /* webpackChunkName: "pages/Policy/privacy" */))
const _40cdb957 = () => interopDefault(import('../pages/Policy/usage.vue' /* webpackChunkName: "pages/Policy/usage" */))
const _117fc121 = () => interopDefault(import('../pages/services/desktop/index.vue' /* webpackChunkName: "pages/services/desktop/index" */))
const _6ac09313 = () => interopDefault(import('../pages/services/mobile/index.vue' /* webpackChunkName: "pages/services/mobile/index" */))
const _0d493064 = () => interopDefault(import('../pages/services/plugin/index.vue' /* webpackChunkName: "pages/services/plugin/index" */))
const _b30a8240 = () => interopDefault(import('../pages/services/website/index.vue' /* webpackChunkName: "pages/services/website/index" */))
const _3457fd46 = () => interopDefault(import('../pages/utils/coming-soon.vue' /* webpackChunkName: "pages/utils/coming-soon" */))
const _bd857426 = () => interopDefault(import('../pages/bloger/_id.vue' /* webpackChunkName: "pages/bloger/_id" */))
const _0ae48ad0 = () => interopDefault(import('../pages/portfolio/_id.vue' /* webpackChunkName: "pages/portfolio/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ar",
    component: _2dba90af,
    name: "index___ar"
  }, {
    path: "/en",
    component: _2dba90af,
    name: "index___en"
  }, {
    path: "/ar/about",
    component: _3aa5a4ed,
    name: "about___ar"
  }, {
    path: "/ar/bloger",
    component: _76ec7645,
    name: "bloger___ar"
  }, {
    path: "/ar/contact",
    component: _23ea8700,
    name: "contact___ar"
  }, {
    path: "/ar/faq",
    component: _0612d276,
    name: "faq___ar"
  }, {
    path: "/en/about",
    component: _3aa5a4ed,
    name: "about___en"
  }, {
    path: "/en/bloger",
    component: _76ec7645,
    name: "bloger___en"
  }, {
    path: "/en/contact",
    component: _23ea8700,
    name: "contact___en"
  }, {
    path: "/en/faq",
    component: _0612d276,
    name: "faq___en"
  }, {
    path: "/ar/about/team",
    component: _45161f92,
    name: "about-team___ar"
  }, {
    path: "/ar/Policy/privacy",
    component: _b289b784,
    name: "Policy-privacy___ar"
  }, {
    path: "/ar/Policy/usage",
    component: _40cdb957,
    name: "Policy-usage___ar"
  }, {
    path: "/ar/services/desktop",
    component: _117fc121,
    name: "services-desktop___ar"
  }, {
    path: "/ar/services/mobile",
    component: _6ac09313,
    name: "services-mobile___ar"
  }, {
    path: "/ar/services/plugin",
    component: _0d493064,
    name: "services-plugin___ar"
  }, {
    path: "/ar/services/website",
    component: _b30a8240,
    name: "services-website___ar"
  }, {
    path: "/ar/utils/coming-soon",
    component: _3457fd46,
    name: "utils-coming-soon___ar"
  }, {
    path: "/en/about/team",
    component: _45161f92,
    name: "about-team___en"
  }, {
    path: "/en/Policy/privacy",
    component: _b289b784,
    name: "Policy-privacy___en"
  }, {
    path: "/en/Policy/usage",
    component: _40cdb957,
    name: "Policy-usage___en"
  }, {
    path: "/en/services/desktop",
    component: _117fc121,
    name: "services-desktop___en"
  }, {
    path: "/en/services/mobile",
    component: _6ac09313,
    name: "services-mobile___en"
  }, {
    path: "/en/services/plugin",
    component: _0d493064,
    name: "services-plugin___en"
  }, {
    path: "/en/services/website",
    component: _b30a8240,
    name: "services-website___en"
  }, {
    path: "/en/utils/coming-soon",
    component: _3457fd46,
    name: "utils-coming-soon___en"
  }, {
    path: "/ar/bloger/:id",
    component: _bd857426,
    name: "bloger-id___ar"
  }, {
    path: "/ar/portfolio/:id?",
    component: _0ae48ad0,
    name: "portfolio-id___ar"
  }, {
    path: "/en/bloger/:id",
    component: _bd857426,
    name: "bloger-id___en"
  }, {
    path: "/en/portfolio/:id?",
    component: _0ae48ad0,
    name: "portfolio-id___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
